module.exports = __webpack_public_path__ + "img/applicant.fea22211.svg";